import { up } from 'styled-breakpoints'
import styled from 'styled-components'

import Label from '~/truck/label'

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  ${up('lg')} {
    flex-grow: 0;
    max-width: 360px;
  }
`

export const NamesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.cozy}px;
`

export const StyledLabel = styled(Label)<{ $visible?: boolean }>`
  visibility: ${props => (props.$visible ? 'visible' : 'hidden')};
`
